import http from '../core/HttpClient';
import { insertParams } from '../core/actionHelpers';
import {
  GET_ALERTS,
  SET_ALERTS_SORT,
  SET_ALERTS_FILTER,
  SET_ALERTS_SEARCH_QUERY,
  RESET_ALERTS_PAGING,
  RESET_ALERTS,
  GET_ALERTS_COUNT,
} from '../constants';

export function getAlerts(params, reqParams) {
  const url = insertParams('/api/alerts', params);
  return {
    type: GET_ALERTS,
    promise: http.get(url, reqParams),
  };
}

export function setSort(sort) {
  return {
    type: SET_ALERTS_SORT,
    sort,
  };
}

export function setFilter(filter) {
  return {
    type: SET_ALERTS_FILTER,
    filter,
  };
}

export function setSearchQuery(searchQuery) {
  return {
    type: SET_ALERTS_SEARCH_QUERY,
    searchQuery,
  };
}

export function resetPaging() {
  return {
    type: RESET_ALERTS_PAGING,
  };
}

export function resetAlerts() {
  return {
    type: RESET_ALERTS,
  };
}

export function getAlertsCount() {
  const url = '/api/alerts/count';
  return {
    type: GET_ALERTS_COUNT,
    promise: http.get(url),
  };
}

export function markAlertAsRead(alertId) {
  return {
    type: 'MARK_ALERT_AS_READ',
    alertId,
    promise: http.post(`/api/alerts/${alertId}?action_type=read`),
  };
}

export function markAllAlertsAsRead() {
  return {
    type: 'MARK_ALL_ALERTS_AS_READ',
    promise: http.post('/api/alerts?action_type=read'),
  };
}

export function markAlertAsSeen(alertId) {
  return {
    type: 'MARK_ALERT_AS_SEEN',
    alertId,
    promise: http.post(`/api/alerts/${alertId}?action_type=seen`),
  };
}

export function markAllAlertsAsSeen() {
  return {
    type: 'MARK_ALL_ALERTS_AS_SEEN',
    promise: http.post('/api/alerts?action_type=seen'),
  };
}



// WEBPACK FOOTER //
// ./src/actions/AlertsActions.js